import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import {
  getBasicDataForRefuelsOfResources,
  selectState,
} from "../slices/dtRefuels.slice";
import { useAppDispatch } from "hooks/hooks";
import { IResourceRefuel } from "../domain/IResourceRefuel";
import Loader from "components/Loader/Loader";
import DateSelector from "Dashboard/components/DateSelector";
import { FormatDateIso, FormatDateShort } from "utils/dateUtils";
import { unitNameLabel } from "Dashboard/scenes/Resources/helpers/resourceUtil";
import { FormatNumberOrNull } from "utils/numberUtils";
import InfoTooltip from "components/Popup/InfoTooltip";

export const FuelPreview = () => {
  const { refuels, loading } = useSelector(selectState);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const dispatch = useAppDispatch();

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  useEffect(() => {
    if (dateFrom && dateTo) {
      dispatch(
        getBasicDataForRefuelsOfResources({
          dateFrom: FormatDateIso(dateFrom),
          dateTo: FormatDateIso(dateTo),
        }));
    }
  }, [dispatch, dateFrom, dateTo]);

  return (
    <div className="daily-table-refuels loading-container">
      {loading && <Loader />}
      <div className="previewHeader">
        <div className="bolded red">GORIVO &nbsp; MAZIVA</div>
        <div>
          <DateSelector showYear={false} selectDate={selectDate} />
        </div>
      </div>
      <div className="extendedPreviewBody">
        {refuels.map((refuel: IResourceRefuel) => (
          <div className="singleFuel">
            <span className="daily-table-refuel-item">- {refuel.consumableItemName}</span>
            <InfoTooltip
              tooltip={`${refuel.projectName && `${refuel.projectName} - `}${refuel.resourceName}`}
              classesProp="daily-table-refuel-project-resource text-overflow"
              element="span"
            >
              {refuel.projectName && `${refuel.projectName} - `}{refuel.resourceName}
            </InfoTooltip>
            <span className="daily-table-refuel-quantity">{FormatNumberOrNull(refuel.quantityAmount)}</span>
            <span className="daily-table-refuel-quantity-unit">{unitNameLabel(refuel.quantityUnit)}</span>
            <span className="daily-table-refuel-usage">{FormatNumberOrNull(refuel.usageAmount)}</span>
            <span className="daily-table-refuel-usage-unit">{unitNameLabel(refuel.usageUnit)}</span>
            <span className="daily-table-refuel-date">{FormatDateShort(refuel.date)}</span>
          </div>
        ))}
        {refuels.length < 4 && <div className="singleFuel"></div>}
        {refuels.length < 3 && <div className="singleFuel"></div>}
        {refuels.length < 2 && <div className="singleFuel"></div>}
        {refuels.length < 1 && <div className="singleFuel"></div>}
      </div>
    </div>
  );
};
